import "./DoorImage.scss";
import { hasDimensions } from "../../services/CabinetValidator";
import { DoorImageFront } from "./DoorImageFront";
import { DoorImageTop } from "./DoorImageTop";
import { useContext } from "react";
import { EditorContext } from "../EditorCommon/EditorContext";
import { GableSide } from "../../models/GableSide";
import { GableImage } from "./GableImage";
import { boundingBoxO2, moveObj } from "../../models/IObj";
import { IVec2d } from "../../services/WebApiClient";

type SvgProps = React.SVGProps<SVGSVGElement>;

type OverriddenSvgProps = Pick<SvgProps, "xmlns" | "xmlnsXlink" | "viewBox">;
type NonOverriddenSvgProperties = Omit<SvgProps, keyof OverriddenSvgProps>;


export function DoorImage(props: NonOverriddenSvgProperties  & {
    onClickDoor?: ((doorIndex: number) => void),
    onClickGable?: ((gableSide: GableSide) => void),
}) {
    const { onClickDoor, onClickGable, className, ...rest } = props;
    const ec = useContext(EditorContext);
    const cabinet = ec.cabinet;
    if (!hasDimensions(cabinet))
        throw new Error("dimensions not defined");

    const paddingBetweenImages = 60;

    const doorInfo = ec.cabinetService.getDoorInfos();
    const doorMinZ = doorInfo.length
        ? Math.min(...doorInfo.map(di => di.position.z))
        : 0;

    const topImageOffset = {
        x: 0,
        y: cabinet.height + (2 * paddingBetweenImages) - doorMinZ,
    };

    const viewBoxDimensions = boundingBoxO2(
        DoorImageFront.boundingBox(ec),
        moveObj(DoorImageTop.boundingBox(ec), topImageOffset),
    );

    function toTransformString(offset: IVec2d): string {
        return `translate( ${offset.x} ${offset.y} )`
    }


    return (
        <svg {...rest}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={`door-image ${className ?? ''}`}
            preserveAspectRatio="xMidYMin meet"
            viewBox={`${viewBoxDimensions.position.x} ${viewBoxDimensions.position.y} ${viewBoxDimensions.size.x} ${viewBoxDimensions.size.y}`}
        >
            <GableImage onClick={onClickGable ? (() => onClickGable(GableSide.Left)) : undefined}
                side={GableSide.Left}
            />
            <GableImage onClick={onClickGable ? (() => onClickGable(GableSide.Right)) : undefined}
                side={GableSide.Right}
            />

            <DoorImageFront onClickDoor={onClickDoor} />


            <g transform={toTransformString(topImageOffset)}>
                <DoorImageTop  />
            </g>
            
        </svg>
    );
}
